import ModalErrorMessage from '@/components/modal/modal-content/ModalErrorMessage.vue';
import Spinner from 'vue-simple-spinner';

export default {
  state: {
    modalVisible: false,
    successModal: {
      text: '',
      type: '',
      visible: false
    },
    componentName: null,
    member: null,
    ticket: null,
    poll: null,
    event: null,
    post: null,
    imageLink: '',
    wider: false,
    transaction: null,
    expense: null,
    invoice: null,
    virtualMember: null,
    virtualMemberList: null,
    document: null,
    infrastructureCategories: [],
    property: null,
    infrastructure: null,
    contractor: null,
    manager: null,
    managerCommunity: null,
    contractorContact: null,
    allProperties: null,
    userDocuments: [],
    reminder: null,
    project: null
  },
  mutations: {
    setVirtualMember(state, virtualMember) {
      state.virtualMember = virtualMember;
    },
    setProperty(state, property) {
      state.property = property;
    },
    setManager(state, manager) {
      state.manager = manager;
    },
    setManagerCommunity(state, managerCommunity) {
      state.managerCommunity = managerCommunity;
    },
    setUserDocuments(state, userDocuments) {
      state.userDocuments = userDocuments;
    },
    setContractor(state, contractor) {
      state.contractor = contractor;
    },
    setProject(state, project) {
      state.project = project;
    },
    setContractorContact(state, contractorContact) {
      state.contractorContact = contractorContact;
    },
    setInfrastructure(state, infrastructure) {
      state.infrastructure = infrastructure;
    },
    setInfrastructureCategories(state, infrastructureCategories) {
      state.infrastructureCategories = infrastructureCategories;
    },
    setDocument(state, document) {
      state.document = document;
    },
    setUserList(state, list) {
      state.virtualMemberList = list;
    },
    setAllProperties(state, allProperties) {
      state.allProperties = allProperties;
    },
    setReminder(state, reminder) {
      state.reminder = reminder;
    },
    removeVirtualMemberList(state) {
      state.virtualMemberList = null;
    },
    removeTicket(state) {
      state.ticket = null;
    },
    removeVirtualMember(state) {
      state.virtualMember = null;
    },
    removeProperty(state) {
      state.property = null;
    },
    removeUserDocuments(state) {
      state.userDocuments = null;
    },
    removeContractor(state) {
      state.contractor = null;
    },
    removeProject(state) {
      state.project = null;
    },
    removeContractorContact(state) {
      state.contractorContact = null;
    },
    removeInfrastructure(state) {
      state.infrastructure = null;
    },
    removeManager(state) {
      state.manager = null;
    },
    removeManagerCommunity(state) {
      state.managerCommunity = null;
    },
    removeAllProperties(state) {
      state.allProperties = null;
    },
    removeReminder(state) {
      state.reminder = null;
    },
    showModal(state, componentName) {
      state.wider = false;
      state.modalVisible = true;
      //state.componentName = componentName;
      state.componentName = () => ({
        component: import(`@/components/modal/modal-content/${componentName}.vue`),
        loading: Spinner,
        delay: 200,
        error: ModalErrorMessage,
        timeout: 10000
      });
      // disable scroll on body
      document.querySelector('body').style = 'overflow: hidden';
    },
    showModalWider(state, componentName) {
      state.wider = true;
      state.modalVisible = true;
      //state.componentName = componentName;
      state.componentName = () => ({
        component: import(`@/components/modal/modal-content/${componentName}.vue`),
        loading: Spinner,
        delay: 200,
        error: ModalErrorMessage,
        timeout: 10000
      });
      // disable scroll on body
      document.querySelector('body').style = 'overflow: hidden';
    },
    closeModal(state) {
      state.modalVisible = false;
      // disable scroll on body
      document.querySelector('body').style = 'overflow: auto';
    },
    closeModalIfOpen(state) {
      if (state.modalVisible) {
        state.modalVisible = false;
        // disable scroll on body
        document.querySelector('body').style = 'overflow: auto';
      }
    },
    setMember(state, payload) {
      state.member = payload;
    },
    setTicket(state, payload) {
      state.ticket = payload;
    },
    setPoll(state, payload) {
      state.poll = payload;
    },
    setEvent(state, payload) {
      state.event = payload;
    },
    setPost(state, payload) {
      state.post = payload;
    },
    setTransaction(state, payload) {
      state.transaction = payload;
    },
    setImageLink(state, payload) {
      state.imageLink = payload;
    },
    setExpense(state, payload) {
      state.expense = payload;
    },
    setInvoice(state, payload) {
      state.invoice = payload;
    },
    setupSuccessModal(state, payload) {
      state.successModal.text = payload.text;
      state.successModal.type = payload.type;
    },
    showSuccessModal(state) {
      state.successModal.visible = true;
    },
    closeSuccessModal(state) {
      state.successModal.visible = false;
    }
  },
  actions: {
    showSuccessModal(context, text = 'Uspešno obavljena akcija') {
      context.commit('setupSuccessModal', {
        text: text,
        type: 'success'
      });
      context.dispatch('blinkSuccessModal');
    },
    showFailModal(context, text = 'Došlo je do greške. Pokušajte kasnije') {
      context.commit('setupSuccessModal', {
        text: text,
        type: 'fail'
      });
      context.dispatch('blinkSuccessModal');
    },
    blinkSuccessModal(context) {
      setTimeout(() => {
        context.commit('showSuccessModal');
      }, 100);

      setTimeout(() => {
        context.commit('closeSuccessModal');
      }, 1500);
    }
  },
  getters: {
    isVisible(state) {
      return state.modalVisible;
    }
  },
  namespaced: true
};
